export const SHOP_PICKER_FETCH_SHOP_AVAILABILITY = "SHOP_PICKER_FETCH_SHOP_AVAILABILITY";
